var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from 'axios';
var QS = require('qs');
import tools from '../util/tools';
import User from '../model/User';
import UIConfirm from '../components/UIConfirm';
//param post参数  method 方法  isJsonString 是否转换为json字符串  isFree 是否需要认证信息
var tplusAjaxReq = function (param, method, isJsonString, isFree, query) {
    param = param || {};
    method = method || '';
    isJsonString = isJsonString || false;
    var requestObj = {};
    //调用REST  传递的是单参数  String类型
    requestObj = QS.stringify({
        'Apis': JSON.stringify(__assign({}, param))
    });
    if (!User.isLogined()) {
        UIConfirm.show("\u7528\u6237\u4FE1\u606F\u4E22\u5931,\u8BF7\u91CD\u65B0\u767B\u5F55!", function () {
            User.logout();
        });
        return;
    }
    var user = User.restore();
    var ajax = axios.create({ baseURL: user.channel.targetURL });
    var url = "api/v2/" + method;
    if (isFree) {
        url = url + '?IsFree=1&userId=' + user.userId + '&orgId=' + user.orgId;
    }
    else {
        url = url + '?userId=' + user.userId + '&orgId=' + user.orgId;
    }
    var user_req_id = user.userId + "x" + new Date().getTime().toString(16);
    url += '&user_req_id=' + user_req_id;
    if (query) {
        url += '&' + query;
    }
    var startTime = new Date().getTime();
    return ajax.post(url, requestObj)
        .then(function (resp) {
        var endTime = new Date().getTime();
        console.log("tApi:\u8BF7\u6C42\u63A5\u53E3[" + method + "]\u6210\u529F,\u6D88\u8017\u65F6\u95F4" + (endTime - startTime) + "ms,\u65F6\u95F4" + tools.sysTime());
        return Promise.resolve(resp);
    }).catch(function (err) {
        var endTime = new Date().getTime();
        console.error("tApi:\u8BF7\u6C42\u63A5\u53E3[" + method + "]\u5931\u8D25,\u6D88\u8017\u65F6\u95F4" + (endTime - startTime) + "ms,\u65F6\u95F4" + tools.sysTime() + ",\u9519\u8BEF\u4FE1\u606F->", err);
        return Promise.reject(err);
    });
};
var TplusApiV2 = function (param, method, isJsonString, isFree, query) { return __awaiter(void 0, void 0, void 0, function () {
    var resp, json;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, tplusAjaxReq(param, method, isJsonString, isFree, query)];
            case 1:
                resp = _a.sent();
                json = resp.data.Value;
                if (typeof (json) == 'string') {
                    if (tools.isJsonStr(json)) {
                        json = JSON.parse(resp.data.Value);
                    }
                }
                return [2 /*return*/, json];
        }
    });
}); };
export default TplusApiV2;

//# sourceMappingURL=TplusApiV2.js.map
